export function log (...args: any[]) {
  // eslint-disable-next-line no-console
  console.log(...args)
}

export function warn (...args: any[]) {
  // eslint-disable-next-line no-console
  console.warn(...args)
}

export function error (...args: any[]) {
  // eslint-disable-next-line no-console
  console.error(...args)
}

export function trace (...args: any[]) {
  // eslint-disable-next-line no-console
  console.trace(...args)
}
